// src/com/trans_plan_tsr/TransPlanTsrEditDetail.js
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import IsValid from '../../value/IsValid';
import VzmTextField from '../../common/VzmTextField';
import VzmIntField from '../../common/VzmIntField';
import Datetime24Picker from '../../common/Datetime24Picker';
import ValueMisc from '../../value/ValueMisc';


const LabelGrid = styled(Grid)({
    display:'flex', justifyContent:'end', paddingRight:5, alignItems:'center', fontSize: '0.8rem'
});

function nullableBol(value) {
    return !Boolean(value) || /^\d{5,18}$/.test(value);
}

function nullableSealNo(value) {
    return !Boolean(value) || /^[A-Z0-9]{5,20}$/.test(value);
}

const DataDict = {
    bol1: {id: 'bol1', check: nullableBol}, // BOL1 00119817021433754
    bol2: {id: 'bol2', check: nullableBol}, // BOL2
    bol3: {id: 'bol3', check: nullableBol}, // BOL3
    loadCount: {id: 'loadCount', min:0, max:999999, check: (value) => value >= 0 && value <= 999999}, // 상차수량
    loadStTime: {id: 'loadStTime', check: (value) => !Boolean(value) || IsValid.datetime(value)}, // 상차시작
    loadEnTime: {id: 'loadEnTime', check: (value) => !Boolean(value) || IsValid.datetime(value)}, // 상차종료
    prosDptrTime: {id: 'prosDptrTime', check: (value) => !Boolean(value) || IsValid.datetime(value)}, // 출발예정
    prosArrTime: {id: 'prosArrTime', check: (value) => !Boolean(value) || IsValid.datetime(value)}, // 도착예정
    sealNo1: {id: 'sealNo1', check: nullableSealNo}, // Seal1
    sealNo2: {id: 'sealNo2', check: nullableSealNo}, // Seal2
    sealNo3: {id: 'sealNo3', check: nullableSealNo}, // Seal3
    loadStaffName: {id: 'loadStaffName', check: (value) => !Boolean(value) || value.length <= 10}, // 상차작업자
    unsoldBol: {id: 'unsoldBol', label: 'BOL', check: nullableBol}, // 전일미출고 BOL
    unsoldPallet: {id: 'unsoldPallet', min:0, max:999999, label: 'Pallet', check: (value) => value >= 0 && value <= 999999}, // 전일미출고 Pallet
    unsoldCount: {id: 'unsoldCount', min:0, max:999999, label: '수량', check: (value) => value >= 0 && value <= 999999}, // 전일미출고 수량
    memo: {id: 'memo', check: (value) => !Boolean(value) || value.length <= 100}, // 특이사항
}

export default function TransPlanTsrEditDetail({
    item,
    onChangeValue,
    onRequestNextView, // 상위 컴포넌트에서 다음 화면으로 이동하도록 요청.
}) {
    const [threeDays, setThreeDays] = useState({yesterday: null, tomorrow: null, today: ValueMisc.getYMD()});

    useEffect(()=>{
        const today = item.planDate;
        const dateToday = ValueMisc.getDateFromYmd(today);
        const yesterday = ValueMisc.getYMD(ValueMisc.addDays(dateToday, -1));
        const tomorrow = ValueMisc.getYMD(ValueMisc.addDays(dateToday, 1));
        setThreeDays({yesterday, tomorrow, today});
    }, [item]);

    return(
        <Grid container spacing={1}>
            <LabelGrid item xs={2}>BOL</LabelGrid>
            <Grid item xs={3}>
                <VzmTextField
                    dict={DataDict.bol1} value={item.bol1}
                    onChange={onChangeValue} fullWidth={true}
                />
            </Grid>
            <Grid item xs={3}>
                <VzmTextField
                    dict={DataDict.bol2} value={item.bol2}
                    onChange={onChangeValue} fullWidth={true}
                />
            </Grid>
            <Grid item xs={3}>
                <VzmTextField
                    dict={DataDict.bol3} value={item.bol3}
                    onChange={onChangeValue} fullWidth={true}
                />
            </Grid>
            <Grid item xs={1}></Grid>
            <LabelGrid item xs={2}>상차수량</LabelGrid>
            <Grid item xs={9}>
                <VzmIntField
                    dict={DataDict.loadCount} value={item.loadCount}
                    onChange={onChangeValue}
                />
            </Grid>
            <Grid item xs={1}></Grid>
            <LabelGrid item xs={2}>상차시작</LabelGrid>
            <Grid item xs={9}>
                <Datetime24Picker
                    dict={DataDict.loadStTime} value={item.loadStTime}
                    onChange={onChangeValue}
                    minDate={threeDays.yesterday}
                    maxDate={threeDays.tomorrow}
                />
            </Grid>
            <Grid item xs={1}></Grid>
            <LabelGrid item xs={2}>상차종료</LabelGrid>
            <Grid item xs={9}>
                <Datetime24Picker
                    dict={DataDict.loadEnTime} value={item.loadEnTime}
                    onChange={onChangeValue}
                    minDate={threeDays.yesterday}
                    maxDate={threeDays.tomorrow}
                />
            </Grid>
            <Grid item xs={1}></Grid>
            <LabelGrid item xs={2}>출발예정</LabelGrid>
            <Grid item xs={9}>
                <Datetime24Picker
                    dict={DataDict.prosDptrTime} value={item.prosDptrTime}
                    onChange={onChangeValue}
                    minDate={threeDays.yesterday}
                    maxDate={threeDays.tomorrow}
                />
            </Grid>
            <Grid item xs={1}></Grid>
            <LabelGrid item xs={2}>도착예정</LabelGrid>
            <Grid item xs={9}>
                <Datetime24Picker
                    dict={DataDict.prosArrTime} value={item.prosArrTime}
                    onChange={onChangeValue}
                    minDate={threeDays.yesterday}
                    maxDate={threeDays.tomorrow}
                />
            </Grid>
            <Grid item xs={1}></Grid>
            <LabelGrid item xs={2}>봉인번호</LabelGrid>
            <Grid item xs={2}>
                <VzmTextField
                    dict={DataDict.sealNo1} value={item.sealNo1}
                    onChange={onChangeValue} fullWidth={true}
                    toUpperCase={true}
                />
            </Grid>
            <Grid item xs={2}>
                <VzmTextField
                    dict={DataDict.sealNo2} value={item.sealNo2}
                    onChange={onChangeValue} fullWidth={true}
                    toUpperCase={true}
                />
            </Grid>
            <Grid item xs={2}>
                <VzmTextField
                    dict={DataDict.sealNo3} value={item.sealNo3}
                    onChange={onChangeValue} fullWidth={true}
                    toUpperCase={true}
                />
            </Grid>
            <Grid item xs={4}></Grid>
            <LabelGrid item xs={2}>상차작업자</LabelGrid>
            <Grid item xs={9}>
                <VzmTextField
                    dict={DataDict.loadStaffName} value={item.loadStaffName}
                    onChange={onChangeValue}
                />
            </Grid>
            <Grid item xs={1}></Grid>
            <LabelGrid item xs={2}>전일미출고</LabelGrid>
            <Grid item xs={3}>
                <VzmTextField
                    dict={DataDict.unsoldBol} value={item.unsoldBol}
                    onChange={onChangeValue} fullWidth={true}
                />
            </Grid>
            <Grid item xs={2}>
                <VzmIntField
                    dict={DataDict.unsoldPallet} value={item.unsoldPallet}
                    onChange={onChangeValue} fullWidth={true}
                />
            </Grid>
            <Grid item xs={2}>
                <VzmIntField
                    dict={DataDict.unsoldCount} value={item.unsoldCount}
                    onChange={onChangeValue} fullWidth={true}
                />
            </Grid>
            <Grid item xs={3}></Grid>
            <LabelGrid item xs={2}>특이사항</LabelGrid>
            <Grid item xs={9}>
                <VzmTextField
                    dict={DataDict.memo} value={item.memo}
                    onChange={onChangeValue} fullWidth={true}
                    onEnterKey={()=>{if(onRequestNextView) onRequestNextView()}}
                    onTabKey={()=>{if(onRequestNextView) onRequestNextView()}}
                />
            </Grid>
            <Grid item xs={1}></Grid>
        </Grid>
    );
}
